import React from 'react';
export default function Blog010() {
  return (
    <section>
    <article>
      <h2>10. 08-22-2022</h2>
      <h3>Programming my own game</h3>
      <p> 
        Hello, <br /><br />
        I am excited to write about the <a
        href="https://ericpolley.github.io/unicornquiz/"
        title="Unicorn Quiz Game! ...Game?" 
      >
        <strong>Unicorn Quiz Game!</strong></a
      > <br /> This Unicorn is the frame, or bones of the project I am creating. This game has 
      all the core functionality. I am now going to take this design and move forward.<br />
      For the last two weeks, 
      I have been narrowing down the tutorials to a goal oriented path. 
      My goal is to create a text-based button game using Javascript. I would like this to 
       be a nice looking game with royalty free images, or images I illustrate myself. I would like 
       the game-play to be at least five minutes. <br />
       I have written out some of the design in a notebook. I have also drawn out a page design
        for how I would like the game to look. I may upload pictures of these drawings in a later 
        blog post. The note book will guide me along as I create this game, and the Unicorn game 
        will be great documentation. <br />
        This project will be heavy on manipulating the DOM. Staying organized will be very important 
        because there will be a lot going on. I am writing everything out to ensure nothing gets missed 
        or I don't waste space with unnecessary code. <br /> <br />
        I have the current set up to look a bit like an old Gameboy. I have a story plot in mind, and 
        a few drawings of the sprites I plan to use. I plan on writing out all the dialog first, in a word 
        document. I can then just paste the text in when I know its proper place. I am going to try and 
        write the code as short and clean as possible, but that is not the focus of this project. 
        <br /><br />
        Instead my focus is on an ascetically pleasing and interactive game. <br /> <br />
        I am sure as I code a few projects, coding logic will apply it's self, and the code will 
        be cleaner. It is a matter of knowing what to use, when. Or, when not to use something. 
        Let's be frank, that's basically programming in a nutshell.

        <br /> <br /> <br /> 
        I plan on recording a vlog video in the next few days. You can check it out on my website linked below.
        I am going to start coding this game project next. <br /> <br />
        I am signing off for now - Eric


        

  


      </p> 
    </article>
 
    <h4>Links</h4>
    <br />
    <ul>

      <li>
        <a
          href="https://ericpolley.github.io/unicornquiz/"
          title="Unicorn Quiz Game! ...Game?"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>Unicorn Quiz Game! ...Game?</p></strong></a
        >
      </li>

      <li>
        <a
          href="https://www.youtube.com/watch?v=6IIY9qJnUXA&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO&index=1"
          title="Vlog"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>THE VLOG - Video Blog Series</p></strong></a
        >
      </li>
      
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
